import React, { Component } from "react";
import PageComponent from './index'
import { connect } from 'react-redux';

class EarthquakePage extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.onLoadHeaderColor("GREEN");
        this.props.onLoadHeaderTheme("DARK");
        this.props.onLoadShowLanguage("HIDE");

        const breadcrumb = [
            { name: "首頁", href: "/" },
            {
                name: "0918池上地震",
                href: "/statistics/ChishangEarthquake",
            },
        ];
        this.props.onLoadShowBreadcrumb("SHOW", breadcrumb);
    }

    render() {
        return <PageComponent />;
    }
}

const mapStateToProps = (state) => ({
    color: state.header.color,
    theme: state.header.theme,
    showLanguage: state.header.showLanguage,
    showBreadcrumb: state.header.showBreadcrumb,
});

const mapDispatchToProps = (dispatch) => ({
    onLoadHeaderColor: (COLOR) => dispatch({ type: "HEADER_COLOR_" + COLOR }),
    onLoadHeaderTheme: (THEME) => dispatch({ type: "HEADER_THEME_" + THEME }),
    onLoadShowLanguage: (STATUS) => dispatch({ type: STATUS + "_LANGUAGE" }),
    onLoadShowBreadcrumb: (STATUS, data) =>
        dispatch({ type: STATUS + "_BREADCRUMB", breadcrumbData: data }),
});

export default connect(mapStateToProps, mapDispatchToProps)(EarthquakePage);